import { Navigate } from "react-router-dom";

import { PATTERNS } from "~/router";

import { getCardSetupReturnPath } from "./cardSetupReturnPath";

/**
 * Stripe's return_url after the embedded setup session saved a card (a full
 * page load): back to where the card dialog was opened, billing by default,
 * telling the page to watch the team.
 */
const CardSetupReturn = () => (
  <Navigate
    to={getCardSetupReturnPath() ?? PATTERNS.billingSubscription}
    state={{ afterCardSetup: true }}
    replace
  />
);

export default CardSetupReturn;
